module.exports = __webpack_public_path__ + "static/media/fresh2.a2e15c00.png";